const DESKTOP_BREAKPOINT = 1023
const SCROLL_OFFSET = 400
const SCROLLED_CLASS = 'stage--scrolled'
// Muss zu $stage-transition-duration in stage.scss passen. Buffer, damit auch
// die letzte ResizeObserver-Auslieferung nach dem transitionend noch mitgenommen wird.
const TRANSITION_WINDOW_MS = 1100

const body = document.body
const stageMedia = document.querySelector('.stage__media')
const stageText = document.querySelector('.stage .element')
const stage = stageMedia?.closest('.stage') ?? null
// Nur die schmale Merch-Buehne waechst beim Scrollen (fixe --stage-height gegen
// den harten calc()-Override). Bei den grossen Buehnen schrumpft die Hoehe, das
// fuehlt sich ohne Kompensation gut an, dort halten wir uns raus.
const needsCompensation = stage?.classList.contains('stage--merch') ?? false

let scrollTicking = false
let compensating = false
let compensationTimer = null
let lastStageHeight = null

function toggleScrolled (shouldBeScrolled) {
  const isScrolled = body.classList.contains(SCROLLED_CLASS)
  if (shouldBeScrolled === isScrolled) return

  if (shouldBeScrolled) body.classList.add(SCROLLED_CLASS)
  else body.classList.remove(SCROLLED_CLASS)

  if (!needsCompensation) return

  compensating = true
  clearTimeout(compensationTimer)
  compensationTimer = setTimeout(() => { compensating = false }, TRANSITION_WINDOW_MS)
}

function checkIfScrolled () {
  if (!stageMedia) return

  const scrollTop = document.documentElement.scrollTop
  const stageHeight = stageMedia.offsetHeight - SCROLL_OFFSET

  toggleScrolled(scrollTop > stageHeight)
}

function onScroll () {
  if (window.innerWidth <= DESKTOP_BREAKPOINT) return
  // Waehrend der Kompensation stossen wir selbst scrollBy() an, das wiederum
  // Scroll-Events feuert. Landet der kompensierte scrollTop knapp jenseits des
  // Thresholds, wuerde checkIfScrolled die Klasse zurueckflippen — die Buehne
  // wachsen/schrumpfen — was die naechste Kompensation triggert. Solange das
  // Toggle-Fenster laeuft, ueberlassen wir die Klassenlage der einen Auswertung,
  // die es beim toggleScrolled() ausgeloest hat.
  if (compensating) return

  if (!scrollTicking) {
    requestAnimationFrame(() => {
      checkIfScrolled()
      scrollTicking = false
    })
    scrollTicking = true
  }
}

if (window.innerWidth > DESKTOP_BREAKPOINT) {
  checkIfScrolled()
}

document.addEventListener('scroll', onScroll)

if (body) {
  const bodyResizeObserver = new ResizeObserver(() => {
    if (window.innerWidth > DESKTOP_BREAKPOINT) {
      checkIfScrolled()
    }
  })
  bodyResizeObserver.observe(body)
}

if (stageText) {
  const stageTextResizeObserver = new ResizeObserver((entries) => {
    for (const entry of entries) {
      document.documentElement.style.setProperty(
        '--stage-text-height',
        entry.contentRect.bottom + entry.contentRect.top + 'px'
      )
    }
  })
  stageTextResizeObserver.observe(stageText)
}

// Waehrend `stage--scrolled` gerade umgeschaltet wurde, gleichen wir jede
// Hoehenaenderung der Buehne per scrollBy aus. So bleibt der Content unterhalb
// waehrend der Transition visuell an derselben Stelle im Viewport, obwohl die
// Buehne oben um ~140px waechst. Ausserhalb des Toggle-Fensters (z. B. bei
// Viewport-Resize) machen wir nichts.
if (stage && needsCompensation) {
  const stageResizeObserver = new ResizeObserver(() => {
    const currentHeight = stage.offsetHeight
    if (lastStageHeight !== null && compensating) {
      const delta = currentHeight - lastStageHeight
      if (delta !== 0) window.scrollBy(0, delta)
    }
    lastStageHeight = currentHeight
  })
  stageResizeObserver.observe(stage)
}
